import { RouterView } from "vue-router";
import { ProjectFundRouting } from "./project-fund/project-fund.routing";
import { CompanyFundRouting } from "./company-fund/company-fund.routing";

export const FinanceRouting = {
  path: "/finance",
  name: "basic-finance",
  redirect: "/finance/category/list",
  component: RouterView,
  meta: { title: "财务管理", icon: "caiwu" },
  children: [...ProjectFundRouting, ...CompanyFundRouting],
};
